/**
 * Action type to set the status of the device.
 */
export const SET_DEVICE_STATUS = 'SET_DEVICE_STATUS';
export const SET_PREJOIN_DEVICE_ERRORS = "SET_PREJOIN_DEVICE_ERRORS";
